
function Queue() {
    return (
        <div id="queue">
            
        </div>
    );
}

export default Queue;